exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recoverPassword{\r\n    color:white;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n}\r\n\r\n.recoverPassword:hover{\r\n    color: #ad3942;\r\n}\r\n\r\n.recoverPasswordContent{\r\n    margin-bottom: 35px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = 16